export interface PrerequisiteCheckResponse {
  prerequisiteDataId: number;
  prerequisitesAreFulfilled: boolean;
}
